export interface MouseUpEvent {
  button: string;
  x: number;
  y: number;
  time: number;
  target: string;
}

export interface ClickEvent {
  button: string;
  x: number;
  y: number;
  time: number;
  target: string;
}

export enum FOCUS_EVENT_TYPE {
  FOCUS = 1,
  UNFOCUS = 0,
}
export interface FocusEvent {
  type: FOCUS_EVENT_TYPE;
  target: string;
  time: number;
}

export interface TouchEvent {
  id: number;
  x: number;
  y: number;
  time: number;
  target: string;
}

export interface MoveEvent {
  x: number;
  y: number;
  time: number;
  target: string;
}

export interface DeviceOrientationEvent {
  alpha: number;
  time: number;
  beta: number;
  gamma: number;
}

export interface SlideEvent {
  t: number;
  x: number;
  y: number;
}


export interface TrackPoint  {
  x: number;
  y: number;
  relative_time: number;
};
